export const min_hour_filters = [
    {
        label: "0 uur",
        value: 0
    },
    {
        label: "8 uur",
        value: 8
    },
    {
        label: "16 uur",
        value: 16
    },
    {
        label: "24 uur",
        value: 24
    },
    {
        label: "32 uur",
        value: 32
    },
    {
        label: "36 uur",
        value: 36
    },
    {
        label: "40 uur",
        value: 40
    }
];

export const max_hour_filters = [
    {
        label: "8 uur",
        value: 8
    },
    {
        label: "16 uur",
        value: 16
    },
    {
        label: "24 uur",
        value: 24
    },
    {
        label: "32 uur",
        value: 32
    },
    {
        label: "36 uur",
        value: 36
    },
    {
        label: "40 uur",
        value: 40
    }
];

export const hour_filters = [
    {
        label: "8 uur",
        value: 8
    },
    {
        label: "16 uur",
        value: 16
    },
    {
        label: "24 uur",
        value: 24
    },
    {
        label: "32 uur",
        value: 32
    },
    {
        label: "36 uur",
        value: 36
    },
    {
        label: "40 uur",
        value: 40
    }
];
